import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase/config";
import imageCompression from "browser-image-compression";
export default function AdminGallery() {

  const [items, setItems] = useState([]);
  const [visibleCount, setVisibleCount] = useState(9); // 🔥 first 9
  const [uploading, setUploading] = useState(false);

  // LOAD
  useEffect(() => {
    const fetch = async () => {
      const snap = await getDoc(doc(db, "siteContent", "gallery"));
      if (snap.exists()) {
        setItems(snap.data().items || []);
      }
    };
    fetch();
  }, []);

  // UPLOAD
 const handleUpload = async (file) => {
  if (!file) return;

  try {
    setUploading(true);

    // 🔥 COMPRESSION SETTINGS
    const options = {
      maxSizeMB: 0.3,               // ~300KB
      maxWidthOrHeight: 1200,       // resize large images
      fileType: "image/webp",       // 🔥 best format
      useWebWorker: true
    };

    // 🔥 COMPRESS IMAGE
    const compressedFile = await imageCompression(file, options);

    const storageRef = ref(
      storage,
      `gallery/${Date.now()}_${compressedFile.name}`
    );

    // 🔥 UPLOAD COMPRESSED IMAGE
    await uploadBytes(storageRef, compressedFile);

    const url = await getDownloadURL(storageRef);

    setItems([
      ...items,
      { src: url, title: "New Image" }
    ]);

  } catch (err) {
    console.error(err);
    alert("Image upload failed");
  }

  setUploading(false);
};

  // DELETE
  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  // CHANGE TITLE
  const changeTitle = (index, value) => {
    const updated = [...items];
    updated[index].title = value;
    setItems(updated);
  };

  // SAVE
  const save = async () => {
    await setDoc(doc(db, "siteContent", "gallery"), {
      items
    });
    alert("Gallery saved ✅");
  };

  const visibleItems = items.slice(0, visibleCount);

  return (
    <div className="admin-section">

      <h2>Gallery</h2>

      {/* UPLOAD */}
      <input
        type="file"
        onChange={(e) => handleUpload(e.target.files[0])}
      />
      {uploading && <p>Uploading...</p>}

      {/* GRID */}
      <div className="gallery-admin-grid">
        {visibleItems.map((img, index) => (
          <div key={index} className="gallery-admin-card">

            <img src={img.src} alt="" />

            <input
              value={img.title}
              onChange={(e) =>
                changeTitle(index, e.target.value)
              }
            />

            <button onClick={() => removeItem(index)}>
              Delete
            </button>

          </div>
        ))}
      </div>

      {/* LOAD MORE */}
      {visibleCount < items.length && (
        <button
          className="load-more-btn"
          onClick={() => setVisibleCount(prev => prev + 9)}
        >
          View More
        </button>
      )}

      {/* SAVE */}
      <button className="save-btn" onClick={save}>
        Save Gallery
      </button>

    </div>
  );
}